const language = {
	en: {
		questionsTab: 'Questions',
		attachmentsTab: 'Attachments',
		commercialTermsTab: 'Rents & SC',
		spacesTab: 'Spaces',
		landlordAndProperty: 'Landlord and Property',
		commercialTerms: 'Commercial Terms',
		buildingStandard: 'Bulding standard and IT infrastructure',
		accessibility: 'Accessibility, amenities and sustainability',
		general: 'General',
		option: 'Option',
		serviceCharge: 'Service charge',
		space: 'Space',
		netSpace: 'Net space',
		grossSpace: 'Gross space',
		office: 'Office',
		retail: 'Retail',
		storage: 'Storage',
		officeSpace: 'Office space',
		retailSpace: 'Retail space',
		storageSpace: 'Storage space',
		parkingUnderground: 'Underground parkings',
		parkingSurface: 'Surface parkings',
		headlineRent: 'Headline rent (m²)',
		rentFree: 'Rent free (mths)',
		fitoutContribution: 'Fitout contribution (m²/net)',
		fitoutContributionComment: 'Fitout contribution comment',
		cashContribution: 'Cash contribution',
		parkings: 'Parkings',
		underground: 'Underground',
		surface: 'Surface',
		answerPlaceholder: 'Please provide your answer',
		attachmentPlaceholder: 'Please provide your answer or name of the uploaded attachment',
		numberPlaceholder: 'Please provide a number here',
		commentPlaceholder: 'Please provide your comment',
		companyPlaceholder: 'Please provide company name',
		landlordPlaceholder: 'Landlord\'s name',
		addressPlaceholder: 'Address',
		rentPlaceholder: 'Ammount',
		SPVAdditionalQuestion: 'Please provide details of ownership structure (SPV’s parent company/companies)',
		powerGeneratorAdditionQuestion: 'Capacity for Tenant\'s use (kVA):',
		dualPowerSupplyAdditionQuestion: 'Please indicate the capacity of each power line:',
		yes: 'Yes',
		no: 'No',
		confirmed: 'Confirmed',
		notConfirmed: 'Not confirmed',
		from: 'From',
		to: 'To',
		of: 'of',
		answered: 'answered',
		save: 'Save',
		edit: 'Edit',
		send: 'Send',
		cancel: 'Cancel',
		delete: 'Delete',
		editGeneralInfo: 'Edit general information',
		editOption: 'Edit option',
		editAttachment: 'Edit attachment',
		addAttachment: 'Add attachments',
		noAttachmentsInfo: 'No attachments yet. Add new attachments using "+" button at right bottom corner.',
		files: 'files',
		filename: 'Filename',
		description: 'Description',
		freehold: 'Freehold',
		usufruct:  'Usufruct',
		rj45Sockets:  'RJ45 sockets',
		powerSockets:  'Power sockets (230V)',
		groupCompany:  'Group companies',
		thirdParty:  '3rd party',
		internalSignage: 'Internal signage',
		externalSignage: 'External signage',
		capacity: 'Capacity (kVA)',
		coolingPower: 'Cooling power',
		coolingPowerLabel: 'Cooling power (W/sqm)',
		freshAirVolume: 'Fresh air volume',
		freshAirVolumeLabel: 'Fresh air volume (cubic meter/hour/workstation)',
		workstationsDensity: 'Workstations’ density',
		workstationsDensityLabel: 'Workstations’ density (sqm/workstation)',
		primaryPowerLine: 'Primary line (kV)',
		primaryPowerLineLabel: 'Primary (base) power line (kV)',
		secondaryPowerLine: 'Secondary line (kV)',
		secondaryPowerLineLabel: 'Secondary power line (kV)',
		applyingTo: 'Applying to:',
		certificate: 'certificate',
		level: 'Level',
		answerSaved: 'Answer has been saved.',
		submitProposal: 'Submit proposal',
		submitProposalTitle: 'All answers are required',
		submitProposalInfo: 'After submitting the proposal you won\'t be able to make changes.',
		proposalSubmitted: 'Proposal submitted',
		proposalSubmittedMessage: 'Proposal has been submitted.',
		month: 'month',
		months1: 'months',
		months2: 'months',
		numberOfOptions: 'Number of proposed options',
		contactPerson: 'Contact person',
		monthlyRentFee: 'Monthly fee',
		fee: 'Fee',
		currency: 'Currency',
		setupFee: 'Setup fee per person',
		parkingFee: 'Parking fee',
		exitFee: 'Total exit fee',
		numberOfWorkstations: 'Number of workstations',
		deposit: 'Deposit',
		comment: 'Comment / Additional description',
		storageAddOn: 'Add-on does not affect storage space',
		noLeasePeriods: 'No lease periods.',
		snackbar: {
			changesSaved: 'Changes have been saved.'
		}
	},
	pl: {
		questionsTab: 'Pytania',
		attachmentsTab: 'Załączniki',
		commercialTermsTab: 'Czynsze & SC',
		spacesTab: 'Powierzchnie',
		landlordAndProperty: 'Właściciel i Budynek',
		commercialTerms: 'Warunki komercyjne',
		buildingStandard: 'Standard Budynku i infrastruktura IT',
		accessibility: 'Dostępność, udogodnienia i środowisko',
		general: 'Ogólne',
		option: 'Opcja',
		serviceCharge: 'Koszty eksploatacyjne',
		space: 'Powierzchnia',
		netSpace: 'Powierzchnia netto',
		grossSpace: 'Powierzchnia brutto',
		office: 'Biurowa',
		retail: 'Handlowa',
		storage: 'Magazynowa',
		officeSpace: 'Powierzchnia biurowa',
		retailSpace: 'Powierzchnia handlowa',
		storageSpace: 'Powierzchnia magazynowa',
		parkingUnderground: 'Parking podziemny',
		parkingSurface: 'Parking naziemny',
		headlineRent: 'Czynsz headline (m²)',
		rentFree: 'Rent free (mths)',
		fitoutContribution: 'Fitout contribution (m²/net)',
		fitoutContributionComment: 'Komentarz do fitout contribution',
		cashContribution: 'Cash contribution',
		parkings: 'Parkingi',
		underground: 'Podziemne',
		surface: 'Naziemne',
		answerPlaceholder: 'Odpowiedź',
		attachmentPlaceholder: 'Odpowiedź lub nazwa pliku',
		numberPlaceholder: 'Podaj liczbę',
		commentPlaceholder: 'Komentarz',
		companyPlaceholder: 'Nazwa firmy',
		landlordPlaceholder: 'Nazwa Właściciela',
		addressPlaceholder: 'Adres',
		rentPlaceholder: 'Kwota',
		SPVAdditionalQuestion: 'Prosimy o opisanie struktury własnościowej (spółka matka).',
		powerGeneratorAdditionQuestion: 'Ilość mocy do użytku Najemcy:',
		dualPowerSupplyAdditionQuestion: 'Prosimy o podanie mocy każdego z przyłączy:',
		yes: 'Tak',
		no: 'Nie',
		confirmed: 'Potwierdzamy',
		notConfirmed: 'Nie potwierdzamy',
		from: 'Od',
		to: 'Do',
		of: 'z',
		answered: 'odpowiedzi',
		save: 'Zapisz',
		edit: 'Edytuj',
		send: 'Wyślij',
		cancel: 'Anuluj',
		delete: 'Usuń',
		editGeneralInfo: 'Edytuj ogólne informacje',
		editOption: 'Edytuj opcję',
		editAttachment: 'Edytuj załącznik',
		addAttachment: 'Dodaj załącznik',
		noAttachmentsInfo: 'Brak załączników. W celu dodania pliku użyj przycisku "+" w prawym dolnym rogu.',
		files: 'plików',
		filename: 'Nazwa pliku',
		description: 'Opis',
		freehold: 'Własność',
		usufruct:  'Użytkowanie wieczyste',
		rj45Sockets:  'Gniazda RJ45',
		powerSockets:  'Gniazda sieciowe (230V)',
		groupCompany:  'Spółki z grupy kapitałowej Najemcy',
		thirdParty:  'Dowolna trzecia strona',
		internalSignage: 'Oznakowanie wewnętrzne',
		externalSignage: 'Oznakowanie zewnętrzne',
		capacity: 'Ilość mocy (kVA)',
		coolingPower: 'Moc chłodzenia',
		coolingPowerLabel: 'Moc chłodzenia (W/m2)',
		freshAirVolume: 'Ilość świeżego powietrza',
		freshAirVolumeLabel: 'Ilość świeżego powietrza (m3/godzina)',
		workstationsDensity: 'Zagęszczenie miejsc pracy',
		workstationsDensityLabel: 'Zagęszczenie miejsc pracy (m2/stanowisko pracy)',
		primaryPowerLine: 'Podstawowa linia (kV)',
		primaryPowerLineLabel: 'Podstawowa linia zasilająca (kV)',
		secondaryPowerLine: 'Zapasowa linia (kV)',
		secondaryPowerLineLabel: 'Zapasowa linia zasilająca (kV)',
		applyingTo: 'Ma zastosowanie do:',
		certificate: 'certyfikat',
		level: 'Poziom',
		answerSaved: 'Odpowiedź został zapisana.',
		submitProposal: 'Wyślij RFP',
		submitProposalTitle: 'Wszystkie odpowiedzi są wymagane',
		submitProposalInfo: 'Po wysłaniu oferty nie będziesz mógł jej edytować.',
		proposalSubmitted: 'RFP wysłane',
		proposalSubmittedMessage: 'RFP zostało wysłane.',
		month: 'miesiąc',
		months1: 'miesięcy',
		months2: 'miesiące',
		numberOfOptions: 'Liczba proponowanych opcji',
		contactPerson: 'Osoba kontaktowa',
		monthlyRentFee: 'Opłata miesięczna',
		fee: 'Opłata',
		currency: 'Waluta',
		setupFee: 'Opłata początkowa od osoby',
		parkingFee: 'Opłata za parking',
		exitFee: 'Całkowita opłata za wyprowadzkę',
		numberOfWorkstations: 'Liczba stanowisk pracy',
		deposit: 'Depozyt',
		comment: 'Komentarz / Opis dodatkowy',
		storageAddOn: 'Add-on nie ma wpływu na powierzchnię magazynową',
		noLeasePeriods: 'Brak okresów najmu.',
		snackbar: {
			changesSaved: 'Zmiany zostały zapisane.'
		}
	}
}

export default language


// WEBPACK FOOTER //
// ./src/utils/lang.js